module.exports = __webpack_public_path__ + "static/media/attach.726c2318.SVG";